import React from 'react';

import { useLocation, useNavigate } from 'react-router';

import { PromotionDetailed } from '@entities/promotion-detailed';

const PromotionDetailedPage = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const { promotionId } = location.state ? location.state : '';

	React.useEffect(() => {
		if (promotionId === undefined) {
			navigate('/all-promotions');
		}
	}, [promotionId, navigate]);

	const id: string = promotionId;

	return <PromotionDetailed id={id} />;
};

export default PromotionDetailedPage;
